<template>
  <div class="navbar-container d-flex content align-items-center">
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">{{ profile.firstName }} {{ profile.lastName }}</p>
            <span class="user-status">{{ $auth && $auth.user ? $auth.user.role : '' }}</span>
          </div>
          <b-avatar
            v-if="$auth.user"
            size="40"
            variant="light-primary"
            badge
            :src="$auth.user.picture"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span @click="onClickProfile">Profile</span>
        </b-dropdown-item>
        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar } from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { mapState } from 'vuex'
import { watch } from '@vue/composition-api'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    // Navbar Components
    DarkToggler
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      firstName: null,
      lastName: null
    }
  },
  computed: {
    ...mapState('userProfile', ['profile'])
  },
  methods: {
    logout() {
      // Clear any cache
      sessionStorage.clear()
      this.$auth.logout({
        returnTo: window.location.origin
      })
    },
    async onClickProfile() {
      if (this.$router.currentRoute.path !== '/account-setting') {
        this.$router.push('/account-setting').catch(_ => {})
      }
    }
  }
}
</script>
